var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex w-full bg-img"})
}
var staticRenderFns = []

export { render, staticRenderFns }